module.exports = __webpack_public_path__ + "img/3.71027bc7.jpg";